import { Component, input, output } from '@angular/core';
import { TDashlet } from 'src/app/project/modules/preferences/preferences.model';
import { getChartName } from '../../../dashboard-export/dashboard-export-elements/dashboard-export-chart-name';

@Component({
  selector: 'pp-rename-dashlet',
  standalone: false,
  templateUrl: './rename-dashlet.component.html',
  styleUrl: './rename-dashlet.component.scss',
})
export class RenameDashletComponent {
  ppDashlet = input<TDashlet>();
  ppDashletChange = output<TDashlet>();
  ppSave = output<TDashlet>();

  dashletType: string;
  dashletName: string;

  ngOnChanges(): void {
    this.dashletType = getChartName(this.ppDashlet().name);
    this.dashletName = this.ppDashlet().customName;
  }

  onNameChange(newName: string): void {
    const updatedDashlet: TDashlet = {
      ...this.ppDashlet(),
      customName: newName,
    };

    this.ppDashletChange.emit(updatedDashlet);
  }

  save(): void {
    const updatedDashlet: TDashlet = {
      ...this.ppDashlet(),
      customName: this.dashletName,
    };

    this.ppSave.emit(updatedDashlet);
  }
}
